export const FLUSH_PROGRAM: 'DASHBOARD/FLUSH_PROGRAM' = 'DASHBOARD/FLUSH_PROGRAM';
export const REQUEST_DASHBOARD: 'DASHBOARD/REQUEST' = 'DASHBOARD/REQUEST';
export const DASHBOARD_LOADING: 'DASHBOARD/LOADING' = 'DASHBOARD/LOADING';
export const RECEIVED_PROGRAM: 'DASHBOARD/RECEIVED_PROGRAM' = 'DASHBOARD/RECEIVED_PROGRAM';
export const RECEIVED_OVERVIEW: 'DASHBOARD/RECEIVED_OVERVIEW' = 'DASHBOARD/RECEIVED_OVERVIEW';
export const REQUEST_DASHBOARD_MEASUREMENT: 'DASHBOARD/REQUEST_MEASUREMENT' = 'DASHBOARD/REQUEST_MEASUREMENT';
export const RECEIVED_DASHBOARD_MEASUREMENT: 'DASHBOARD/RECEIVED_MEASUREMENT' = 'DASHBOARD/RECEIVED_MEASUREMENT';
export const REQUEST_DASHBOARD_MEASUREMENT_DIAGRAM: 'DASHBOARD/REQUEST_MEASUREMENT_DIAGRAM' =
	'DASHBOARD/REQUEST_MEASUREMENT_DIAGRAM';
export const RECEIVED_DASHBOARD_MEASUREMENT_DIAGRAM: 'DASHBOARD/RECEIVED_MEASUREMENT_DIAGRAM' =
	'DASHBOARD/RECEIVED_MEASUREMENT_DIAGRAM';
export const REQUEST_SAVE_DASHBOARD_MEASUREMENT: 'DASHBOARD/REQUEST_DASHBOARD_SAVE_MEASUREMENT' =
	'DASHBOARD/REQUEST_DASHBOARD_SAVE_MEASUREMENT';
export const REQUEST_SAVE_DASHBOARD_MEASUREMENT_SUCCESS: 'DASHBOARD/REQUEST_SAVE_DASHBOARD_MEASUREMENT_SUCCESS' =
	'DASHBOARD/REQUEST_SAVE_DASHBOARD_MEASUREMENT_SUCCESS';
